export const SL_REARRANGE_QUESTION = 'sl-rearrange-question';
